export default __webpack_public_path__ + "0913261b5a29453ba30b4dbf463b7c12.png";